<template lang="pug">
#care-lebel-label.register-row
  .register-group
    .register-key
      span.key-name 介護度
    .register-value
      .d-flex.flex-column(v-if="_value")
        .d-flex.flex-row.flex-wrap.mb-2
          .care-level-label.d-flex.flex-row.align-items-center
            FacilityAcceptMark(:value="_value.careLevel1000")
            span 自立
          .care-level-label.d-flex.flex-row.align-items-center
            FacilityAcceptMark(:value="_value.careLevel1010")
            span 申請中
        .d-flex.flex-row.flex-wrap.mb-2
          .care-level-label.d-flex.flex-row.align-items-center
            FacilityAcceptMark(:value="_value.careLevel2010")
            span 要支援１
          .care-level-label.d-flex.flex-row.align-items-center
            FacilityAcceptMark(:value="_value.careLevel2020")
            span 要支援２
        .d-flex.flex-row.flex-wrap.mb-2
          .care-level-label.d-flex.flex-row.align-items-center
            FacilityAcceptMark(:value="_value.careLevel3010")
            span 要介護１
          .care-level-label.d-flex.flex-row.align-items-center
            FacilityAcceptMark(:value="_value.careLevel3020")
            span 要介護２
          .care-level-label.d-flex.flex-row.align-items-center
            FacilityAcceptMark(:value="_value.careLevel3030")
            span 要介護３
          .care-level-label.d-flex.flex-row.align-items-center
            FacilityAcceptMark(:value="_value.careLevel3040")
            span 要介護４
          .care-level-label.d-flex.flex-row.align-items-center
            FacilityAcceptMark(:value="_value.careLevel3050")
            span 要介護５
      .d-flex.flex-column(v-else)
        .error-message 未設定
      
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { CareLevels } from "@/commons/services/Facilities";

import FacilityAcceptMark from "@/pc/basics/FacilityAcceptMark.vue";

@Component({
  components: {
    FacilityAcceptMark
  }
})
export default class CareLebelLabel extends Vue {
  @Prop()
  value!: CareLevels;

  get _value(): CareLevels {
    return this.value;
  }
}
</script>

<style lang="scss" scoped>
#care-lebel-label {
  .care-level-label {
    width: 160px;
  }
}
</style>
